import { bugReportMutations } from './bugReport';
import { suggestionCommentMutations } from './suggestionComments';
import { userSuggestionMutations } from './userSuggestions';

export const feedbackMutations = {
  ...userSuggestionMutations,
  ...suggestionCommentMutations,
  ...bugReportMutations,
};
